import { render } from "./PersonaRecibeCertificadoComponent.vue?vue&type=template&id=0760dbde"
import script from "./PersonaRecibeCertificadoComponent.vue?vue&type=script&lang=js"
export * from "./PersonaRecibeCertificadoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__